import { usePersistedSessionState } from '@edreamsodigeo/frontend-core';

const pathRegex = /#pf[a-z]+\/(\d+)\/(\d+)\/([\d,]+)/;

function getPathParams(url) {
  const result = url.match(pathRegex);

  if (!result) {
    return null;
  }

  return {
    searchId: result[1],
    fareItineraryKey: result[2],
    segmentKeys: result[3].split(',').map(Number),
  };
}

function useSessionFlightSelection() {
  const [flightSelectionData] = usePersistedSessionState('flightSelectionData');

  if (!(flightSelectionData && flightSelectionData.data)) {
    return null;
  }

  return {
    searchId: flightSelectionData.data.searchId,
    fareItineraryKey: flightSelectionData.data.fareItineraryKey
      .split(',')[0]
      ?.split('_')[0],
    segmentKeys: flightSelectionData.data.segmentKeys,
  };
}

export function useFlightSelection(url = '') {
  const selectionData = useSessionFlightSelection();
  const pathParams = getPathParams(url);

  if (!pathParams && !selectionData) {
    return null;
  }

  return pathParams ? pathParams : selectionData;
}
